module.exports = __webpack_public_path__ + "img/jbt8010-6.asm.b8a6bf16.jpg";